import React from "react";
import useOpportunityModel from "../../../../api/hooks/models/useOpportunityModel";
import { FieldPath } from "../../../../react-hook-form";
import { VeriAsyncSelect } from "../../drop-down/VeriAsyncSelect";
import { VeriOpportunitySelectProps } from "./VeriOpportunitySelect.types";

const VeriOpportunitySelect = <T, K extends FieldPath<T>>({
  managerId,
  usePlacement,
  isInvestor,
  isInvestedIn,
  pageSize,
  separateManagerId,
  requestParams,
  ...rest
}: VeriOpportunitySelectProps<T, K>) => {
  const opportunityModel = useOpportunityModel(
    usePlacement !== undefined ? { usePlacement } : undefined,
  );

  return (
    <VeriAsyncSelect
      label={"Opportunity"}
      onFilter={async (searchFilter) => {
        return (
          (
            await opportunityModel.getMany(undefined, {
              "filter[search]": searchFilter,
              ...(managerId ? { "filter[manager_id]": managerId } : undefined),
              "page[size]": pageSize || 25,
              "page[number]": 1,
              ...(isInvestor ? { is_investor: true } : {}),
              ...(isInvestedIn ? { invested_in: true } : {}),
              ...(separateManagerId ? { manager_id: managerId } : {}),
              ...requestParams,
            })
          )?.data || []
        ).map((opportunity) => ({
          label: opportunity.name || "",
          value: String(opportunity.id),
          ...opportunity,
        }));
      }}
      renderOption={(option) => option.name}
      placeholder={"Search or select an opportunity"}
      {...rest}
    />
  );
};

export default VeriOpportunitySelect;
